import { Reveal, SectionHeader } from "@/components/Reveal";

const PHILOSOPHY_IMG = "/images/jared-cage.jpg";

const PILLARS = [
  {
    heading: "Transfer Over Numbers",
    text: "A big squat means nothing if it doesn't show up in your swing, your throw, or your first step. Everything we do is built to transfer onto the field.",
  },
  {
    heading: "Explosiveness Is The Game",
    text: "Baseball is a game of violent, split-second actions. We train the nervous system to produce force fast — not just to move weight slowly.",
  },
  {
    heading: "Availability Wins",
    text: "You can't perform from the training room. Durability, mobility, and smart workload management keep you on the field all season.",
  },
];

export default function Philosophy() {
  return (
    <section className="relative py-24 sm:py-32 lg:py-40 overflow-hidden" data-testid="philosophy-section">
      <div className="absolute inset-0">
        <img
          src={PHILOSOPHY_IMG}
          alt=""
          className="w-full h-full object-cover object-center opacity-35"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C] via-[#0B0B0C]/60 to-[#0B0B0C]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B0B0C] via-[#0B0B0C]/50 to-transparent" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader index="04" label="Coaching Philosophy" title="Strong In The Gym. Dangerous On The Field." />
        <Reveal delay={0.1}>
          <p className="max-w-3xl text-lg sm:text-xl text-zinc-300 leading-relaxed mb-16">
            The goal isn't just getting stronger under a bar. It's transferring
            strength, power, speed, and explosiveness onto the baseball field —
            into your swing, your arm, your first step, and your ability to do it
            again tomorrow.
          </p>
        </Reveal>
        <div className="grid gap-px bg-zinc-800 md:grid-cols-3 border border-zinc-800">
          {PILLARS.map((p, i) => (
            <Reveal key={p.heading} delay={0.1 + i * 0.12} className="h-full">
              <div
                className="h-full bg-[#0B0B0C] p-8 sm:p-10 group"
                data-testid={`philosophy-pillar-${i}`}
              >
                <span className="block h-0.5 w-10 bg-[#CCFF00] mb-8 transition-all duration-500 group-hover:w-20" />
                <h3 className="font-display uppercase text-2xl sm:text-3xl text-white tracking-wide mb-4 leading-none">
                  {p.heading}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
